module.exports = __webpack_public_path__ + "static/member-3-8a6654a8df725186136b2eb13409bac4.png";